var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications-item",style:(_vm.backgroundColor ? { backgroundColor: _vm.backgroundColor } : null)},[_c('div',{staticClass:"notifications-item__container"},[_c('div',{staticClass:"notifications-item__text",style:(_vm.textColor ? { color: _vm.textColor } : null),domProps:{"innerHTML":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }